import styled from "styled-components";
import { SearchOutlined } from "@assets";
import { Input, Space, Col as AntCol, Image as AntImage } from "antd";
import { DefaultIMG } from '@assets';

export const RootContainer = styled.div`
position: relative;
`;

export const Container = styled.div`
padding: 16px;
`;

export const TabsWrapper = styled(Space)`
  margin-top: 12px;
  padding: 0 16px;
  width: calc(100% - 32px);
  overflow: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const Tab = styled.div`
padding: 8px 12px;
border-radius: 8px;
background: ${props => props.status === 'active' ? 'linear-gradient(90deg, #FFB829 0%, #914706 100%)' : '#212224'};

font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: normal;
color: #fff;
overflow: hidden;
white-space: nowrap;
cursor: pointer;
`;

export const SearchInput = styled(Input).attrs({
  prefix: <SearchOutlined />
})`
margin-bottom: 16px;
height: 44px;
padding: 10px 12px;
border-radius: 8px;
border: 1px solid #212224;
background: #212224;

input {
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #F9F9F9;
    background: #212224;

    ::placeholder {
      color: #686B6E;
    }
}

.anticon {
    color: #DEDEDE;
    font-size: 24px;
    margin-right: 8px;
}

:hover, :focus {
    border-color: #212224 !important;
    box-shadow: none !important;
}
`;

export const Col = styled(AntCol)`
width: 25%;
text-align: center;

@media screen and (max-width: 426px) {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

@media screen and (max-width: 400px) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
`;

export const Image = styled(AntImage).attrs({
  alt: "gameicon",
  fallback: DefaultIMG,
  preview: false,
})`
    width: 100%;
    border-radius: 8px;
    box-shadow: 0px 4px 19px 0px rgba(0, 0, 0, 0.10), 0px 2px 6px 0px rgba(0, 0, 0, 0.20);
    object-fit: cover;
    aspect-ratio: 1;
    cursor: pointer;
`;

export const Text = styled.div`
  width: 100%;
  padding-top: 6px;
  display: inline-block;

  font-size: 10px;
  font-style: normal;
  font-weight: 200;
  line-height: normal;
  color: #F9F9F9;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SpinWrapper = styled.div`
height: calc(100vh - 145px);
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`;